import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../lib/utils'; // Assuming utils exists, if not I'll create it or inline it.
// Actually, to be safe and self-contained, I will implement clsx/tailwind-merge logic simply or just use template literals if utils is missing.
// I'll stick to template literals for simplicity in this generated code to ensure it works without extra dependencies.
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
}
export function Button({
  className,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-full font-bold transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-[#F97316] hover:bg-[#ea580c] text-white shadow-lg shadow-orange-500/30 hover:shadow-orange-500/50',
    secondary: 'bg-[#0ABFBC] hover:bg-[#089e9b] text-white shadow-lg shadow-teal-500/30',
    outline: 'border-2 border-[#1a1a2e] text-[#1a1a2e] hover:bg-[#1a1a2e] hover:text-white',
    ghost: 'text-[#1a1a2e] hover:bg-gray-100'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-11 px-6 text-base',
    lg: 'h-14 px-8 text-lg',
    xl: 'h-16 px-10 text-xl'
  };
  const width = fullWidth ? 'w-full' : '';
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${width} ${className || ''}`} {...props} data-id="element-221">
      {children}
    </motion.button>;
}